import { useQuery } from '@tanstack/react-query';
import { Form } from 'antd';
import { useContext } from 'react';

import { useFilteredRooms } from 'app/components/pages/Extranet/ExtranetInventory/Modern/hooks/useFilteredRooms';
import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { CORE_QUERY_KEYS } from 'app/hooks/data/core/extranet/inventory';
import {
  AUTO_INVENTORY_ROOMS_STALE_TIME,
  fetchAutoInventoryRooms,
} from 'app/hooks/data/core/extranet/inventory/rooms/useAutoInventoryRooms';

export const useRoomMapping = () => {
  const { hotelId } = useContext(HotelContext);

  const { sortedRooms } = useFilteredRooms();

  const { data: autoInventoryRooms, isLoading } = useQuery({
    queryKey: [CORE_QUERY_KEYS.autoInventoryRooms, { hotelId }],
    queryFn: () => fetchAutoInventoryRooms(hotelId),
    staleTime: AUTO_INVENTORY_ROOMS_STALE_TIME,
    enabled: !!hotelId,
  });

  const bookingRooms =
    autoInventoryRooms?.map(({ roomId, roomName }) => ({ roomId, roomName })) ??
    [];

  const roomMappings = Form.useWatch('roomMappings') as
    { scrappedRoomId?: number }[] | undefined;

  const isOptionDisabled = (bookingRoomId: number): boolean =>
    (roomMappings ?? []).some((rm) => rm?.scrappedRoomId === bookingRoomId);

  return {
    rooms: sortedRooms ?? [],
    bookingRooms,
    isLoading,
    isOptionDisabled,
  };
};
